// extracted by mini-css-extract-plugin
export default {"alert":"alertModal_alert__Tz5zR"};